<template lang="html">

<!-- <slot name="header" :snack_bar="snack_bar"/> -->
  <StandardTextCard :name="client.name">
    <template #info>
      <v-row>
        <v-col cols="5" class="clients-setting-default-height">
          <v-list two-line avatar color="color-2">
            <v-subheader>Details</v-subheader>
            <v-list-item @click="selectIndex(-4)" :style="selected_index === -4? 'background-color: #616161':''">
              <v-list-item-avatar  color="grey">
                <span class="white--text">{{ client.name[0].toUpperCase() }}</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ client.name }} details</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-subheader>Callbacks</v-subheader>
            <v-list-item @click="selectIndex(-1)" :style="selected_index === -1? 'background-color: #616161':''">
              <v-list-item-avatar :color="getHTTPColor('POST')">
                <span class="white--text">POST</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>TAKT.entities are being created</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="selectIndex(-2)" :style="selected_index === -2? 'background-color: #616161':''">
              <v-list-item-avatar :color="getHTTPColor('PUT')">
                <span class="white--text">PUT</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>TAKT.entities are being updated</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="selectIndex(-3)" :style="selected_index === -3? 'background-color: #616161':''">
              <v-list-item-avatar :color="getHTTPColor('DELETE')">
                <span class="white--text">DEL</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>TAKT.entities are being deleted</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-subheader>Projects</v-subheader>
            <v-list-item v-for="(project, index) in client.projects" :key="'clientproject'+index"
              @click="selectIndex(index)" :style="selected_index === index? 'background-color: #616161':''">
              <v-list-item-avatar color="grey">
                <span class="white--text">{{ project.name[0].toUpperCase() }}</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{project.name}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="cursor-pointer" @click="$router.push({ name: 'AccountClientsAddProjects', params: { client_id: client.id}})">
              <v-list-item-avatar  color="grey" small>
                <v-icon>add</v-icon>
              </v-list-item-avatar>
              <v-list-item-content >
                Add Projects
              </v-list-item-content>
            </v-list-item>
            <template v-if="hasBusiness && hasBusinessPermission('Add Clients')">
              <v-subheader>Company</v-subheader>
              <v-list-item v-if="client.business" @click="selectIndex(-10)" :style="selected_index === -10? 'background-color: #616161':''">
                <v-list-item-avatar color="grey">
                  <span class="white--text">{{ client.business.name[0].toUpperCase() }}</span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{client.business.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else class="cursor-pointer" @click="addClientToBusiness({ client_id: client.id }) ">
                <v-list-item-avatar  color="grey" small>
                  <v-icon>add</v-icon>
                </v-list-item-avatar>
                <v-list-item-content >
                  Add to {{ $store.state.Auth.current_user.business.name }}
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
        <v-col cols="7" class="clients-setting-default-height">
          <div v-if="selected_index >= 0">
            <h3>{{ client.name }} in {{ client.projects[selected_index].name }}</h3>
            <v-list two-line color="color-2">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">assignment_ind</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ client.projects[selected_index].prole_name }}
                  <v-list-item-subtitle>
                    Role
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-bg">
                <v-list-item-action>
                  <v-icon color="snow">cancel</v-icon>
                </v-list-item-action>
                <v-list-item-content v-if="!show_delete">
                  <v-btn @click="show_delete=true" text>Remove Client from {{client.projects[selected_index].name}}</v-btn>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-btn @click="removeClientFromProject({
                      project_id: client.projects[selected_index].id,
                      payload: { clients: [ { id: client.id, prole: client.projects[selected_index].prole_id } ]},
                    })" text>Click again to remove</v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-if="selected_index === -1">
            <h3>
              <v-avatar :color="getHTTPColor('POST')">
                <span class="white--text">POST</span>
              </v-avatar>
              TAKT.entities are being created
            </h3>
            <StandardCallback :base_uri="client.base_uri" :callbacks="getPOSTCallbacks" @updateCallback="updateCallback($event)">
              <template #add-callback>
                <v-list-item v-if="hasPermission('Callback CREATE')">
                  <v-list-item-avatar
                    class="cursor-pointer" color="grey" small
                    @click="!add_new ? addNewCallback('POST') : addCallbacks({payload: new_callback})">
                    <v-icon v-if="!add_new">add</v-icon>
                    <v-icon class="ml-1" v-else>send</v-icon>
                  </v-list-item-avatar>
                  <div v-if="add_new">
                    <v-list-item-content>
                      <StandardTextfield
                        color="grey darken-1"
                        textcolor="white"
                        placeholder="CALLBACK.callback_uri"
                        :value="new_callback.callback_uri"
                        @changeValue="setNewCallbackUri($event)"
                        style="width: 90%"
                        />
                      <StandardDropdown
                        class="ma-0"
                        header="Callback HTTP Method:"
                        :value="new_callback.callback_http_method"
                        @changeValue="new_callback.callback_http_method = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="[{name: 'POST'}, {name: 'PUT'}, {name: 'DELETE'}]"
                        style="width: 90%"
                      />
                      <StandardDropdown
                        class="ma-0"
                        header="Takt Entity:"
                        :value="new_callback.takt_entity"
                        @changeValue="new_callback.takt_entity = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="getTAKTEntityOptions()"
                        :limit_height="true"
                        style="width: 90%"
                      />
                    </v-list-item-content>
                  </div>
                  <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                    Add new Callback
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template #remove-callback="{cb}">
                <StandardDeleteButton @clickDelete="$emit('removeCallback', { callback_id: cb.id })" />
              </template>
            </StandardCallback>
          </div>
          <div v-if="selected_index === -2">
            <h3>
              <v-avatar :color="getHTTPColor('PUT')">
                <span class="white--text">PUT</span>
              </v-avatar>
              TAKT.entities are being updated
            </h3>
            <StandardCallback :base_uri="client.base_uri" :callbacks="getPUTCallbacks" @updateCallback="updateCallback($event)">
              <template #add-callback>
                <v-list-item v-if="hasPermission('Callback CREATE')">
                  <v-list-item-avatar
                    class="cursor-pointer" color="grey" small
                    @click="!add_new ? addNewCallback('PUT') : addCallbacks({payload: new_callback})">
                    <v-icon v-if="!add_new">add</v-icon>
                    <v-icon class="ml-1" v-else>send</v-icon>
                  </v-list-item-avatar>
                  <div v-if="add_new">
                    <v-list-item-content>
                      <StandardTextfield
                        color="grey darken-1"
                        textcolor="white"
                        placeholder="CALLBACK.callback_uri"
                        :value="new_callback.callback_uri"
                        @changeValue="setNewCallbackUri($event)"
                        style="width: 90%"
                        />
                      <StandardDropdown
                        class="ma-0"
                        header="Callback HTTP Method:"
                        :value="new_callback.callback_http_method"
                        @changeValue="new_callback.callback_http_method = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="[{name: 'POST'}, {name: 'PUT'}, {name: 'DELETE'}]"
                        style="width: 90%"
                      />
                      <StandardDropdown
                        class="ma-0"
                        header="Takt Entity:"
                        :value="new_callback.takt_entity"
                        @changeValue="new_callback.takt_entity = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="getTAKTEntityOptions()"
                        :limit_height="true"
                        style="width: 90%"
                      />
                    </v-list-item-content>
                  </div>
                  <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                    Add new Callback
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template #remove-callback="{cb}">
                <StandardDeleteButton @clickDelete="$emit('removeCallback', { callback_id: cb.id })" />
              </template>
            </StandardCallback>
          </div>
          <div v-if="selected_index === -3">
            <h3>
              <v-avatar :color="getHTTPColor('DELETE')">
                <span class="white--text">DEL</span>
              </v-avatar>
              TAKT.entities are being deleted
            </h3>
            <StandardCallback :base_uri="client.base_uri" :callbacks="getDELETECallbacks" @updateCallback="updateCallback($event)">
              <template #add-callback>
                <v-list-item v-if="hasPermission('Callback CREATE')">
                  <v-list-item-avatar
                    class="cursor-pointer" color="grey" small
                    @click="!add_new ? addNewCallback('DELETE') : addCallbacks({payload: new_callback})">
                    <v-icon v-if="!add_new">add</v-icon>
                    <v-icon class="ml-1" v-else>send</v-icon>
                  </v-list-item-avatar>
                  <div v-if="add_new">
                    <v-list-item-content>
                      <StandardTextfield
                        color="grey darken-1"
                        textcolor="white"
                        placeholder="CALLBACK.callback_uri"
                        :value="new_callback.callback_uri"
                        @changeValue="setNewCallbackUri($event)"
                        style="width: 90%"
                        />
                      <StandardDropdown
                        class="ma-0"
                        header="Callback HTTP Method:"
                        :value="new_callback.callback_http_method"
                        @changeValue="new_callback.callback_http_method = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="[{name: 'POST'}, {name: 'PUT'}, {name: 'DELETE'}]"
                        style="width: 90%"
                      />
                      <StandardDropdown
                        class="ma-0"
                        header="Takt Entity:"
                        :value="new_callback.takt_entity"
                        @changeValue="new_callback.takt_entity = $event.name"
                        placeholder="Callback HTTP Method"
                        :options="getTAKTEntityOptions()"
                        :limit_height="true"
                        style="width: 90%"
                      />
                    </v-list-item-content>
                  </div>
                  <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                    Add new Callback
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template #remove-callback="{cb}">
                <StandardDeleteButton @clickDelete="$emit('removeCallback', { callback_id: cb.id })" />
              </template>
            </StandardCallback>
          </div>
          <div v-if="selected_index === -4">
            <h3>{{ client.name }}</h3>
            <v-list two-line color="color-2">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">cloud</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <!-- {{ client.base_uri }} -->
                  <StandardTextfield
                    color="color-2"
                    textcolor="white"
                    :value="client.base_uri"
                    :readonly="false"
                    type="text"
                    style="width: 90%"
                    @changeValue="$emit('updateClient', { base_uri: $event })"
                    />
                  <v-list-item-subtitle>
                    URI
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">check_box</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ getClientStatus(client.activated) }}
                  <v-list-item-subtitle>
                    Status
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">assignment_ind</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <div class="client-details-flex">
                    <span class="mr-1" v-for="(role, role_index) in client.roles" :key="`clientrole${role.id}`">
                      {{ role.name }}<span v-if="role_index < client.roles.length - 1">,</span>
                    </span>
                  </div>
                  <v-list-item-subtitle>
                    Role
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">api</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ client.identifier }}
                  <v-list-item-subtitle>
                    Client ID
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon @click="show_client_secret = !show_client_secret" color="blue">api</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <StandardTextfield
                    color="color-2"
                    textcolor="white"
                    :value="client.client_secret"
                    :readonly="true"
                    :type="show_client_secret ? 'text' : 'password'"
                    style="width: 90%"
                    />
                  <!-- {{ client.identifier }} -->
                  <v-list-item-subtitle>
                    Client Secret
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-if="selected_index === -10">
            <h3>{{ client.name }} in {{ client.business.name }}</h3>
            <v-list two-line color="color-2">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="blue">assignment_ind</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ client.business.brole_name }}
                  <v-list-item-subtitle>
                    Role
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item class="list-item-bg">
                <v-list-item-action>
                  <v-icon color="snow">cancel</v-icon>
                </v-list-item-action>
                <v-list-item-content v-if="!show_delete">
                  <v-btn @click="show_delete=true" text>Remove Client from {{client.business.name}}</v-btn>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-btn @click="removeClientFromProject({
                      project_id: client.business.id,
                      payload: { clients: [ { id: client.id, prole: client.business.brole_id } ]},
                    })" text>Click again to remove</v-btn>
                </v-list-item-content>
              </v-list-item> -->
            </v-list>
          </div>
        </v-col>
      </v-row>
    </template>
  </StandardTextCard>
</template>
<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue'
import StandardCallback from '@/components/StandardComponents/StandardCallback.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    StandardTextCard,
    StandardCallback,
    StandardTextfield,
    StandardDropdown,
    StandardDeleteButton
  },
  props: ['client'],
  data: function () {
    return {
      selected_index: -4,
      show_client_secret: false,
      show_delete: false,
      add_new: false,
      new_callback: {
        callback_uri: '',
        callback_http_method: '',
        takt_entity: 'Project WORK.package',
        takt_http_method: ''
      }
    }
  },
  computed: {
    getPOSTCallbacks: function () {
      return this.client.callbacks.filter( callback => callback.takt_http_method === 'POST');
    },
    getPUTCallbacks: function () {
      return this.client.callbacks.filter( callback => callback.takt_http_method === 'PUT');
    },
    getDELETECallbacks: function () {
      return this.client.callbacks.filter( callback => callback.takt_http_method === 'DELETE');
    },
    ...mapGetters('Auth', [
      'hasPermission',
      'hasBusiness'
    ]),
    ...mapGetters('Business', [
      'hasBusinessPermission'
    ])
  },
  methods: {
    addNewCallback(method){
      this.new_callback.callback_http_method = method;
      this.new_callback.takt_http_method = method;
      this.add_new = true;
    },
    setNewCallbackUri(callback_uri){
      this.new_callback.callback_uri = callback_uri;
    },
    resetNewCallback(){
      this.add_new = false;
      this.new_callback = {
        callback_uri: '',
        callback_http_method: '',
        takt_entity: 'Project WORK.package',
        takt_http_method: ''
      };
    },
    getTAKTEntityOptions(){
      let entities = [{name: 'Project WORK.package'}];
      if (this.hasPermission('Client TEST')) {
        entities.push({name: 'Project COST.step'});
        entities.push({name: 'Project LOGISTIC.step'});
        entities.push({name: 'Project DESIGN.step'});
        entities.push({name: 'Project HANDOVER.step'});
        entities.push({name: 'Project DEFECT.step'});
        entities.push({name: 'Project QUALITY.step'});
        entities.push({name: 'Project MATERIAL.step'});
        entities.push({name: 'Project WORK.step'});
        entities.push({name: 'Project Material'});
        entities.push({name: 'Project WAGON'});
        entities.push({name: 'Project TAKT.area'});
        entities.push({name: 'Project TRAIN'});
        entities.push({name: 'Company Sequence'});
        entities.push({name: 'Company Sequence Wagon'});
        entities.push({name: 'Company Sequence WORK.package'});
        entities.push({name: 'Company Sequence WORK.step'});
        entities.push({name: 'Company Sequence QUALITY.step'});
        entities.push({name: 'Company Sequence DEFECT.step'});
        entities.push({name: 'Company Sequence DESIGN.step'});
        entities.push({name: 'Company Sequence LOGISTIC.step'});
        entities.push({name: 'Company Sequence HANDOVER.step'});
        entities.push({name: 'Company Sequence COST.step'});
        entities.push({name: 'Company Sequence TOOL.step'});
        entities.push({name: 'Company Sequence MATERIAL.step'});
        entities.push({name: 'Company WORK.package'});
        entities.push({name: 'Company WORK.package WORK.step'});
        entities.push({name: 'Company WORK.package QUALITY.step'});
        entities.push({name: 'Company WORK.package DEFECT.step'});
        entities.push({name: 'Company WORK.package DESIGN.step'});
        entities.push({name: 'Company WORK.package LOGISTIC.step'});
        entities.push({name: 'Company WORK.package HANDOVER.step'});
        entities.push({name: 'Company WORK.package COST.step'});
        entities.push({name: 'Company WORK.package TOOL.step'});
        entities.push({name: 'Company WORK.package MATERIAL.step'});
      }
      return entities;
    },
    getHTTPColor(method){
      switch (method) {
        case 'POST':
          return '#d89f39';
        case 'PUT':
          return '#3a81ba';
        case 'DELETE':
          return '#963334';
      }
    },
    getHTTPMethod(method){
      if (method === 'DELETE') {
        return 'DEL';
      }
      return method;
    },
    selectIndex(index){
      this.selected_index = index;
      this.resetNewCallback();
    },
    getClientStatus(status){
      if (status) {
        return 'Active';
      }
      return 'Inactive';
    },
    removeClientFromProject(payload){
      this.$emit('removeClientFromProject', payload);
      this.show_delete = false;
      this.selected_index = -4;
    },
    updateCallback(payload){
      payload.client_id = this.client.id;
      this.$emit('updateCallback', payload);
    },
    addCallbacks(payload){
      payload.client_id = this.client.id;
      if (payload.payload.takt_http_method === '') {
        payload.payload.takt_http_method = payload.payload.callback_http_method;
      }
      this.$emit('addCallbacks', payload);
      let self = this;
      setTimeout(function () {
        self.resetNewCallback();
      }, 500);
    },
    ...mapActions('Client', [
      'addClientToBusiness'
    ])
  }
}
</script>
<style>
.clients-setting-default-height {
  max-height: 60vh;
  overflow-y: auto;
}
.list-item-bg {
  background-color: red;
}
.client-details-flex {
  display: flex;
}
</style>
